import { devices_config_wave } from 'src/devices_config_wave';

/**
 * Maps BE Z-Wave device shape (`type=relay`, `code=ZW-*`, `gen=GXZ`) to the FE model
 * (`type=ZW-*`, wave `category`/`mode`, `gen=GZ`). Returns true when any field changed.
 */
export const applyZWaveDeviceNormalization = (device: Record<string, any> | undefined): boolean => {
	if (!device) return false;

	const isZw =
		device.gen === 'GXZ' ||
		device.gen === 'GZ' ||
		(typeof device.type === 'string' && device.type.startsWith('ZW-')) ||
		(typeof device.code === 'string' && device.code.startsWith('ZW-')) ||
		(typeof device.id === 'string' && device.id.startsWith('XZ'));
	if (!isZw) return false;

	let changed = false;

	if (
		typeof device.code === 'string' &&
		device.code.startsWith('ZW-') &&
		device.type !== device.code
	) {
		device.type = device.code;
		changed = true;
	}

	const waveType =
		(typeof device.type === 'string' && device.type.startsWith('ZW-') && device.type) ||
		(typeof device.code === 'string' && device.code.startsWith('ZW-') && device.code) ||
		undefined;

	const waveConfig = waveType ? devices_config_wave[waveType] : undefined;
	const waveFamily = waveConfig?.family;
	if (waveFamily) {
		if (device.category !== waveFamily) {
			device.category = waveFamily;
			changed = true;
		}
		const waveMode = Object.keys(waveConfig.modes || {})[0];
		if (waveMode && device.mode !== waveMode) {
			device.mode = waveMode;
			changed = true;
		}
		if (typeof device.type !== 'string' || !device.type.startsWith('ZW-')) {
			device.type = waveType;
			changed = true;
		}
	}

	if (device.gen !== 'GZ') {
		device.gen = 'GZ';
		changed = true;
	}

	return changed;
};
